import { defineComponent as _defineComponent } from 'vue'
import {
  TUIGlobal,
  TUIChatService,
  TUIStore,
  StoreName,
  IConversationModel,
  SendMessageParams,
} from "@tencentcloud/chat-uikit-engine";
import { ref, defineEmits } from "../../../../adapter-vue";

import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import fileIcon from "../../../../assets/icon/files.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["close"],
  setup(__props, { emit: emits }) {



const inputRef = ref();
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onIconClick = () => {
  if (isUniFrameWork.value) {
    // uniapp app 不支持选择文件发送
    return;
  } else {
    inputRef?.value?.click && inputRef?.value?.click();
  }
};

const sendFileMessage = (e: any) => {
  if (e?.target?.files?.length <= 0) {
    return;
  }
  const options = {
    to:
      currentConversation?.value?.groupProfile?.groupID ||
      currentConversation?.value?.userProfile?.userID,
    conversationType: currentConversation?.value?.type,
    payload: {
      file: e?.target,
    },
  } as SendMessageParams;
  TUIChatService.sendFileMessage(options);
  e.target.value = '';
};

return { __sfc: true,emits, inputRef, isPC, isUniFrameWork, currentConversation, onIconClick, sendFileMessage, ToolbarItemContainer, fileIcon }
}

})